import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SessionService } from "../session.service";
import {
  faUserCircle,
  faBell,
  faBuilding,
} from "@fortawesome/free-regular-svg-icons";
import { faSitemap, faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import { FacilityDTO } from "../facilities/Facility";
import { AccountAppDTO } from "../apps/AccountApp";
import { NotificationService } from "../notifications/notification.service";
import { UserDTO } from "../auth/User";
import { AvailableAccount } from "../accounts/AvailableAccount";
import { sortBy } from "lodash";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  faSitemap = faSitemap;
  faUserCircle = faUserCircle;
  faBell = faBell;
  faBuilding = faBuilding;
  faMobileAlt = faMobileAlt;
  constructor(
    private SessionService: SessionService,
    private router: Router,
    private NotificationService: NotificationService,
  ) {}

  ngOnInit(): void {}

  logOut() {
    this.SessionService.logout();
    this.router.navigate(["auth", "login"]);
  }

  get user() {
    return this.SessionService.currentUserValue;
  }

  get loggedIn() {
    return !!this.user;
  }

  get accounts() {
    return this.SessionService.availableAccounts;
  }

  get hasAccounts() {
    return !!this.accounts?.length;
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  get facilities() {
    return this.SessionService.facilitiesValue!;
  }

  get selectedFacilities() {
    return sortBy(this.SessionService.selectedFacilities, ['name']);
  }

  get apps() {
    return this.SessionService.apps;
  }

  get currentApp() {
    return this.SessionService.currentAppValue;
  }

  get hasApps() {
    return !!this.apps?.length;
  }

  get notifications() {
    return this.NotificationService.notifications;
  }

  get unreadNotificationsCount() {
    return this.NotificationService.unreadNotificationCount;
  }

  get isDocsRoute() {
    return this.router.url.startsWith("/docs");
  }

  get currentUser(): UserDTO {
    return this.SessionService.currentUserValue!;
  }

  goToUserPreferences() {
    this.router.navigate(["users", this.currentUser.id, "preferences"], {
      replaceUrl: true,
    });
  }

  isCurrentAccount(account: AvailableAccount) {
    return this.currentAccount?.accountID === account.accountID;
  }

  changeAccount(account: AvailableAccount) {
    this.SessionService.changeAccount(account);
    this.router.navigate([""]);
  }

  selectAllFacilities(event: any) {
    event.stopPropagation()
    this.SessionService.setSelectAllFacilities();
  }

  selectNoFacilities(event: any) {
    event.stopPropagation()
    this.SessionService.setSelectedNoFacilities();
  }

  onFacilitySelectedChange(facility: FacilityDTO) {
    facility.selected = !facility.selected;
    this.SessionService.setSelectedFacilities();
  }

  isCurrentApp(app: AccountAppDTO) {
    return this.currentApp?.id === app.id;
  }

  changeApp(app: AccountAppDTO) {
    this.SessionService.setApp(app);
  }

  toggleNotifications() {
    this.NotificationService.toggleNotificationsEvent.emit();
  }
}
